import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-scrollerMenu';
	$(base, context).each(function(i, el){
		var $el = $(el);
		var links = $el.find(base + '-list a');
		var container = $el.find(base + '-container');

		function handleClick(e) {
			e.preventDefault();
			scrollToActiveItem();
		}

		if ($el.data('clicked') == true) {
			links.on('active', handleClick);
			links.on('click', handleClick);
		}

		function scrollToActiveItem() {
			var active = el.querySelector('.m-active');
			if (!active) return;
			var scrollParent = container[0];
			var scrollParentWidth = scrollParent.clientWidth;
			var activeElWidth = active.clientWidth;
			var activeElLeftOffset = active.offsetLeft;
			var isActiveElInvisible = activeElLeftOffset + activeElWidth != scrollParentWidth;

			if (isActiveElInvisible) {
				scrollParent.scrollLeft = activeElLeftOffset - (scrollParentWidth / 2) + (activeElWidth / 2);
			} else {
				scrollParent.scrollLeft = 0;
			}
		}

		scrollToActiveItem();

		$(window).on('resize', scrollToActiveItem);
	});
});
